import * as R from "fp-ts-routing"
import * as t from "io-ts"
import * as A from "fp-ts/Array"
import { pipe } from "fp-ts/function"
import { forbiddenRoutes } from "./runtimeVariables"

export type Route = Home | Dashboard | NotFound

export type Home = {
  readonly _tag: "Home"
}

export type NotFound = {
  readonly _tag: "NotFound"
}

export type Dashboard = {
  readonly _tag: "Dashboard"
  readonly propcode: string
  readonly tab: Tab
}

const DashboardTab = t.keyof({
  overview: null,
  viewings: null,
  feedback: null,
  rentals: null,
})

export type Tab = t.TypeOf<typeof DashboardTab>

const home: Route = { _tag: "Home" }
const notFound: Route = { _tag: "NotFound" }
const dashboard = (propcode: string, tab: Tab): Route => ({
  _tag: "Dashboard",
  propcode,
  tab,
})

export const homeMatch = R.end
export const dashboardMatch = R.lit("dashboard")
  .then(R.str("propcode"))
  .then(R.type("tab", DashboardTab))
  .then(R.end)

const router = R.zero<Route>()
  .alt(homeMatch.parser.map(() => home))
  .alt(
    dashboardMatch.parser.map(({ propcode, tab }) => dashboard(propcode, tab))
  )

export const parseLocation = (path: string): Route =>
  R.parse(router, R.Route.parse(path), notFound)

export const isAllowedRoute = (pathname: string): boolean => {
  return pipe(
    forbiddenRoutes,
    A.filter(pattern => !!pathname.match(pattern)),
    A.isEmpty
  )
}

export const dahboardTabValue = (tab: Tab): string => {
  switch (tab) {
    case "overview": {
      return "Overview"
    }
    case "feedback": {
      return "Feedback"
    }
    case "viewings": {
      return "Viewings"
    }

    case "rentals": {
      return "Rentals"
    }
  }
}
